import { Injectable } from '@angular/core';
import { HttpService } from "../core/http/http.service";
import { ModelStateValidationService } from "../_services";
import { ISystemTable } from '../_entities';

@Injectable()
export class SystemTableMenuService  {
    constructor(private readonly httpService: HttpService,
        private readonly validationService: ModelStateValidationService) {
    }

    getControllerUrl(): string {
        return `api/systemtable`;
    }

    getItems(): Promise<ISystemTable[] | void> {
        return this.httpService.get(`${this.getControllerUrl()}/menu`)
            .then((tables: any) => {
                const items = new Array<ISystemTable>();
                for (let table of tables) {
                    items.push(this.getTableItem(table));
                }
                return items;
            });
    }

    private getTableItem(table: any): ISystemTable {
        const item: ISystemTable = {
            systemTable: table["systemTable"] as string,
            title: table["title"] + "",
            group: table["group"] + ""
        };
        return item;
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shell/system-table-menu.service.ts